<div class="picker-dialog">
  <h1 class="strong" mat-dialog-title>
    {{ 'shared.picker.employee.heading' | translate }}
  </h1>
  <div mat-dialog-content>
    <div class="employee-picker-search-container">
      <app-actions-header
        [hasFilterFields]="true"
        [hasOperators]="true"
        [hasSearchField]="true"
        [hasClearFiltersBtn]="true"
        [filterFields]="searchFilterFields"
        (searchOptionsChanged)="onSearchValueChange($event)"
        (clearFiltersButtonClicked)="clearFilters()"
      >
      </app-actions-header>
    </div>
    <div class="difaTable-container">
      <app-table
        [loading]="employeePickerIsLoading$ | async"
        [selectable]="true"
        [multipleSelect]="employeePickerData.multipleSelection"
        [selectedRows]="this.employeePickerData.alreadySelectedEmployees ? this.employeePickerData.alreadySelectedEmployees : []"
        [preSelectedFilterOptions]="preSelectedPersistentFilters"
        [columns]="employeePickerColumnConfig"
        [data]="employees"
        [isTableInsideDialog]="true"
        [hasFooter]="false"
        [mode]="TABLE_MODE.SERVER"
        [total]="totalCount()"
        [pagination]="true"
        [pageSize]="pageSize()"
        [page]="currentPage()"
        [serverSort]="sort()"
        [serverFilters]="appliedFilters()"
        [endpoint]="getFilterValuesEndpoint"
        [employeeFilter]="employeePickerData.filter"
        (pageChange)="onPageChanged($event)"
        (serverSortChange)="onServerSortChange($event)"
        (serverFilterChange)="onFilterChange($event)"
        (selectionChange)="addOrRemoveEmployeeToSelection($event)"
      >
      </app-table>
    </div>
  </div>
  <div mat-dialog-actions>
    <button class="btn btn-secondary" (click)="close()">
      {{ 'default.close' | translate }}
    </button>
    <button class="btn btn-primary" (click)="emitSelectedEmployees()">
      {{ 'default.apply' | translate }}
    </button>
  </div>
</div>
